import { gql } from '@/__generated__';

export const upsertProductDocument = gql(/* GraphQL */ `
  mutation UpsertProduct(
    $where: ProductWhereUniqueInput!
    $create: ProductCreateInput!
    $update: ProductUpdateInput!
  ) {
    upsertProduct(where: $where, create: $create, update: $update) {
      id
    }
  }
`);
